import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import AppBar from "./Components/AppBar";

import Home from "./Components/Home";
import { UserAuthContextProvider } from "./Context/UserAuthContext";
import SignIn from "./Auth/SignIn";
import { RequireAuth } from "./Auth/RequireAuth";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import './App.css';
import PrintReport from "./Components/PrintReport";
import AlertComp from "./Components/AlertComp";
import Report from "./Components/Report";
import User from "./Components/User";
import Chats from "./Components/Chats";
import AnnualReport from "./Components/AnnualReport";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

function App() {

  useEffect(()=> {
    document.title = "Stay Alert Web Admin";
  }, [])

  return (
    <React.Fragment>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Box sx={{ height: "100vh" }}>
          <UserAuthContextProvider>
            <Routes>
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="/print" element={<PrintReport />} />
              <Route
                exact
                path="/print-annual-report"
                element={
                  <>
                    <RequireAuth>
                      <AnnualReport/>
                    </RequireAuth>
                  </>
                }
              />
              <Route
                exact
                path="/"
                element={
                  <>
                    <RequireAuth>
                      <AppBar />
                      <Home />
                    </RequireAuth>
                  </>
                }
              />
              <Route
                exact
                path="/report"
                element={
                  <>
                    <RequireAuth>
                      <AppBar />
                      <Report/>
                    </RequireAuth>
                  </>
                }
              />
              <Route
                exact
                path="/user"
                element={
                  <>
                    <RequireAuth>
                      <AppBar />
                      <User/>
                    </RequireAuth>
                  </>
                }
              />
               <Route
                exact
                path="/chats"
                element={
                  <>
                    <RequireAuth>
                      <AppBar />
                      <Chats/>
                    </RequireAuth>
                  </>
                }
              />
              <Route path="/alert-mode" element={<>
                <RequireAuth>
                  <AppBar />
                  <AlertComp />
                </RequireAuth>
              </>} />
            </Routes>
          </UserAuthContextProvider>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
}

export default App;
